import { Layout, Modal } from "antd";
import { Content } from "antd/es/layout/layout";
import _ from "lodash";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import { v4 as uuidv4 } from "uuid";

import { ReactComponent as ICON_ARROW_BACK_MENU } from "@assets/svgs/ICON_ARROW_BACK_MENU.svg";
import { Button } from "@components/Button";
import Header from "@components/Header";
import { Icon } from "@components/Icon";
import { InnerContents } from "@components/InnerContents";
import { SideMenu } from "@components/SideMenu";
import { Text } from "@components/Text";
import { COLOR_GREEN, COLOR_GREY, COLOR_WHITE } from "@static/COLORS";
import { CONTENT_STYLES } from "@static/CONTENT_STYLES";
import { KEY_CAMPAIGNS_ADD } from "@static/PERMISSION_KEY";
import { MENU_SIZE } from "@static/SIZE";
import { getAuthUserPermissions } from "@utils/getAuthUserPermissions";
import { fetchAPI } from "@utils/https/fetchAPI";

import { BlockItem } from "./BlockItem";
import { ManageBlock } from "./ManageBlock";
import { RenderInnerMediaBlock } from "./RenderInnerMediaBlock";

const SectionCreate = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
`;

const SectionMainAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${COLOR_WHITE};
  padding: 8px;
  border-radius: 6px;
  height: 50px;
  box-sizing: border-box;
`;

const SectionLocationTextContainer = styled.div`
  margin-right: 8px;
  width: 300px;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 4px;
`;

const Line = styled.div`
  height: 20px;
  width: 1px;
  background: ${COLOR_GREY};
`;

const SectionBlocks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  /* border-radius: 6px; */
`;

const SectionEditor = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  height: auto;
`;

const SectionFrame = styled.div`
  position: relative;
  background: ${COLOR_WHITE};
  border: 1px solid ${COLOR_GREY};
  width: 100%;
  height: auto;
  aspect-ratio: ${({ width, height }) => `${width} / ${height}`};
  box-sizing: border-box;
`;

const ContainerMediaBlock = styled.div`
  position: absolute;
  top: ${({ y }) => y * 100}%;
  left: ${({ x }) => x * 100}%;
  background: ${({ backgroundColor }) => backgroundColor};
  width: ${({ width }) => width * 100}%;
  height: ${({ height }) => height * 100}%;
  aspect-ratio: ${({ width, height }) => `${width} / ${height}`};
  opacity: 0.5;
  cursor: pointer;
`;

const InnerMediaBlock = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const BLOCK_COLORS = [
  "Red",
  "Green",
  "Blue",
  "Yellow",
  "Purple",
  "Orange",
  "Pink",
  "Brown",
  "Cyan",
  "Gray",
];

export default () => {
  const navigate = useNavigate();
  const location = useLocation();
  const permission = getAuthUserPermissions();
  const defaultAdsBlocks = _.get(location, ["state", "adsBlocks"]);
  const locationState = _.get(location, ["state"]);
  const selectedCampaign = _.chain(location)
    .get(["state"])
    .omit(["adsBlocks"])
    .value();

  const [adsBlocks, setAdsBlocks] = useState(defaultAdsBlocks);
  const [defaultCampaign, setDefaultCampaign] = useState(selectedCampaign);

  const [isModalVisible, setIsModalVisible] = useState({
    isOpen: false,
    modalType: null,
  });
  const [selectedBlock, setSelectedBlock] = useState(null);

  const campaignWidth = _.get(locationState, ["campaign_width"]);
  const campaignHeight = _.get(locationState, ["campaign_height"]);

  const onHandleAddBlock = () => {
    const updateBlock = {
      id: uuidv4(),
      block_key: uuidv4(),
      advertising_campaign_id: _.get(locationState, ["campaign_id"]),
      name: `BLOCK-${_.size(adsBlocks) + 1}`,
      width: _.get(locationState, ["campaign_width"]),
      height: _.get(locationState, ["campaign_height"]),
      position_x: 0,
      position_y: 0,
      blockMedias: [],
    };
    setAdsBlocks((prev) => [...prev, { ...updateBlock }]);
  };

  const onHandleUpdateBlockInputValue = ({ index, name, value }) => {
    const updatedBlocks = _.chain(adsBlocks)
      .cloneDeep()
      .set([index, name], value)
      .value();
    setAdsBlocks(updatedBlocks);
  };

  const onHandleDeleteBlock = (index) => {
    const updatedBlocks = _.filter(adsBlocks, (filterItem, filterIndex) => {
      return filterIndex !== index;
    });
    setAdsBlocks(updatedBlocks);
  };

  const onHandleOpenModal = ({ item }) => {
    setSelectedBlock(item);
    setIsModalVisible({ isOpen: true, modalType: "manage-block" });
  };

  const onHandleSubmit = async () => {
    const resp = await fetchAPI({
      method: "post",
      path: "/api/v1/advertising-campaigns-update-ads-blocks-and-block-medias",
      isAuth: true,
      data: {
        advertising_campaign_id: _.get(defaultCampaign, ["campaign_id"]),
        adsBlocks,
      },
    });

    if (_.get(resp, ["status"])) {
      const results = _.chain(resp).get(["result"]).value();
      // setAdsBlocks(_.get(results, ["adsBlocks"]));
      navigate(-1);
      toast.success("Save Campaign Blocks Success.");
    }
  };
  return (
    <Layout hasSider>
      <SideMenu />
      <Layout style={{ marginLeft: MENU_SIZE }}>
        <Header />
        <Content style={CONTENT_STYLES}>
          <InnerContents>
            <SectionMainAction>
              <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
                <Button onClick={() => navigate(-1)} padding="0px">
                  <Icon
                    isCursor
                    width={14}
                    height={14}
                    style={{ marginRight: 8 }}
                  >
                    <ICON_ARROW_BACK_MENU />
                  </Icon>
                  <Text fontSize="18px" fontWeight="600">
                    Back
                  </Text>
                </Button>
                <Line />

                <SectionLocationTextContainer>
                  <Text
                    fontSize="16px"
                    fontWeight="400"
                    color="rgb(150 150 150)"
                  >
                    Campaign
                  </Text>
                  <Text
                    fontSize="16px"
                    fontWeight="400"
                    color="rgb(150 150 150)"
                  >
                    :
                  </Text>
                  <Text
                    fontSize="16px"
                    fontWeight="500"
                    isEllipsis
                    lines={1}
                    isBreak
                  >
                    {_.get(defaultCampaign, ["campaign_name"])}
                  </Text>
                </SectionLocationTextContainer>
              </div>

              <SectionCreate>
                {_.includes(permission, KEY_CAMPAIGNS_ADD) && (
                  <Button
                    onClick={() => onHandleAddBlock()}
                    color={COLOR_GREEN}
                    fontColor={COLOR_WHITE}
                    padding="7px 15px"
                  >
                    Add Blocks
                  </Button>
                )}

                {_.includes(permission, KEY_CAMPAIGNS_ADD) && (
                  <Button
                    onClick={() => onHandleSubmit()}
                    color={COLOR_GREEN}
                    fontColor={COLOR_WHITE}
                    padding="7px 15px"
                  >
                    Save
                  </Button>
                )}
              </SectionCreate>
            </SectionMainAction>
            <SectionEditor>
              <SectionBlocks>
                {_.map(adsBlocks, (item, index) => {
                  const itemId = _.get(item, ["id"]);
                  return (
                    <BlockItem
                      key={itemId}
                      item={item}
                      index={index}
                      onHandleOpenModal={onHandleOpenModal}
                      onHandleUpdateBlockInputValue={
                        onHandleUpdateBlockInputValue
                      }
                      onHandleDeleteBlock={onHandleDeleteBlock}
                    />
                  );
                })}
              </SectionBlocks>
              <SectionFrame
                width={_.get(locationState, ["campaign_width"])}
                height={_.get(locationState, ["campaign_height"])}
              >
                <Text
                  fontWeight="600"
                  fontSize={"22px"}
                  color={COLOR_GREY}
                  align="center"
                >
                  Campaign Layout
                </Text>
                {_.map(adsBlocks, (item, index) => {
                  const x = _.get(item, ["position_x"]);
                  const y = _.get(item, ["position_y"]);
                  const blockWidth = _.get(item, ["width"]);
                  const blockHeight = _.get(item, ["height"]);
                  const colorBlock = _.get(BLOCK_COLORS, [
                    index % _.size(BLOCK_COLORS),
                  ]);

                  const firstBlockMedia = _.chain(item)
                    .get(["blockMedias"])
                    .first()
                    .value();
                  return (
                    <ContainerMediaBlock
                      onClick={() => onHandleOpenModal({ item })}
                      backgroundColor={colorBlock}
                      key={index}
                      x={x / campaignWidth}
                      y={y / campaignHeight}
                      width={blockWidth / campaignWidth}
                      height={blockHeight / campaignHeight}
                    >
                      <RenderInnerMediaBlock
                        index={index}
                        firstBlockMedia={firstBlockMedia}
                      />
                    </ContainerMediaBlock>
                  );
                })}
              </SectionFrame>
            </SectionEditor>
          </InnerContents>
        </Content>
      </Layout>
      <Modal
        width={"80%"}
        destroyOnClose={true}
        title={`Medias ${_.chain(selectedBlock)
          .get(["name"])
          .capitalize()
          .value()}`}
        open={_.get(isModalVisible, ["isOpen"])}
        footer={null}
        onCancel={() =>
          setIsModalVisible((prev) => ({ ...prev, isOpen: false }))
        }
      >
        {_.get(isModalVisible, ["modalType"]) === "manage-block" && (
          <ManageBlock
            adsBlocks={adsBlocks}
            setIsModalVisible={setIsModalVisible}
            setAdsBlocks={setAdsBlocks}
            campaignData={selectedCampaign}
            selectedBlock={selectedBlock}
            blockMedias={_.get(selectedBlock, ["blockMedias"])}
          />
        )}
      </Modal>
    </Layout>
  );
};
